<template>
    <div>
        <div v-if="props.form && props.form.provider === 'ppl'">
            <AdminDeliveryPplType v-model="modelValue.type" />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { FieldComponent } from '@src/Common/Components/types';
import AdminDeliveryPplType from '@src/DeliveryPpl/Pages/Fields/AdminDeliveryPplType.vue';

const modelValue = defineModel({
    type: Object,
});

const props = withDefaults(defineProps<FieldComponent>(), {});
</script>
